import { Inject } from '@angular/core';
import { Http, Headers, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Environment } from '../app.environment';
import { Observable } from 'rxjs';

export class AwsEndpoints{

  public dataUser: any[];
  examList: any = {};
  httpOptions: any;
  httpFormOptions: any;

  static bearerToken: string;
  static awsBearerToken: string;
  static awsIdToken: string;
  static awsXkey: string;
 
  constructor(@Inject(Environment) private env: Environment, @Inject(Http) private http: Http) {  
  }

  

  private convertToUrlSearchParams(obj: any) {
    let params = new URLSearchParams();
    for (let key in obj) {
        params.append(key, obj[key].toString());
    }

    return params;
  }

  awsRequest<T>(method: string, relativeUrl: string, searchParams?: any, requestBody?: any, requestHeaders?: Headers, useBearerToken = true): Observable<T> {
    let options = new RequestOptions();
    options.headers = requestHeaders || new Headers();
    options.method = method.toUpperCase();

    options.body = options.body || requestBody;
    // console.log(`logging options.body 
         
    // route -> ${relativeUrl}

    // body -> ${JSON.stringify(options.body)}
    
    // ` )
    if (searchParams) options.search = options.search || this.convertToUrlSearchParams(searchParams);

    options.headers.append('Content-Type', 'application/json');
    options.headers.append('x-api-key',  AwsEndpoints.awsXkey);
   
    if (AwsEndpoints.awsBearerToken) {
        options.headers.append('Authorization', 'Bearer ' + AwsEndpoints.awsBearerToken);
    }

    console.log('CALLING AWS:', this.env.settings.awsUrl + relativeUrl);
    
    return this.http.request(this.env.settings.awsUrl + relativeUrl, options)
        .map((res: Response) => { return res.json(); })
        .map((stream => { return stream; }))
        .share();;
  } 

  awsMediaRequest<T>(relativeUrl: string,  files: File[], useBearerToken = true): Observable<T> {
    return Observable.create(observer => {
      let formData: FormData = new FormData();
      let xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(xhr.response);
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      for (let i = 0; i < files.length; i++) {
        formData.append('file', files[i], files[i].name)
      }
      console.log('CALLING AWS MEDIA: ', this.env.settings.awsMediaUrl + relativeUrl + '/' + AwsEndpoints.awsBearerToken);
      xhr.open('POST', this.env.settings.awsMediaUrl + relativeUrl + '/' + AwsEndpoints.awsBearerToken, true);
      // xhr.setRequestHeader('Accept', 'application/json');
      // if (AwsEndpoints.awsBearerToken && useBearerToken) {
      //   xhr.setRequestHeader('Authorization', 'Bearer ' + AwsEndpoints.awsBearerToken);
      // }
    xhr.send(formData);
  });
  }

  filePost<T>(relativeUrl: string, files: File[], useBearerToken = true): Observable<T> {
    return Observable.create(observer => {
      let formData: FormData = new FormData();
      let xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      for (let i = 0; i < files.length; i++) {
        formData.append('files[]', files[i], files[i].name)
      }
      console.log('CALLING AWS FILEPOST: ', this.env.settings.apiUrl + relativeUrl);
      xhr.open('POST', this.env.settings.apiUrl + relativeUrl, true);
      // xhr.setRequestHeader('Accept', 'application/json');
      if (AwsEndpoints.awsBearerToken && useBearerToken) {
        xhr.setRequestHeader('Authorization', 'Bearer ' + AwsEndpoints.awsBearerToken);
      }
    xhr.send(formData);
  });
}



/**
 * 
 * @param result : this is the result value of the lambda api response. this does not work with observables but the object only. 
 */  
camelCaseResult(result) {
  if(result == null) {
    console.log(`
    ************
    result is null, exiting camelCaseResult function
    ************`)
    return;
  } 

  if(Array.isArray(result)){
    var response =[];
    for(let i = 0; i < result.length; ++i) {
      var t = this._camelCaseResult(result[i]); 
      response.push(t);
    }
    return response;
  }
  else{
    return this._camelCaseResult(result); 
  }
}   

_camelCaseResult(result) {
  let temp = result;
    for(let i = 0; i < Object.keys(result).length; ++i) {
      let temp = result;
      let tempString;
      if(Object.keys(result)[0].substring(0, 2) == 'ID') {
        tempString = Object.keys(result)[0].substring(0, 2).toLowerCase() + Object.keys(result)[0].substring(2);
      }
      else if(Object.keys(result)[0].substring(0, 3) == 'DOB') {
        tempString = Object.keys(result)[0].substring(0, 3).toLowerCase();
      }
      else {
        tempString = Object.keys(result)[0][0].toLowerCase() + Object.keys(result)[0].substring(1);
      }
      let value = result[Object.keys(result)[0]];
      delete temp[Object.keys(result)[0]];
      temp[tempString] = value;
    } 

    return temp;
} 



  camelCase(response) {
    return response.subscribe((res) => {
      if(res.result == null) {
        console.log(`
        ************
        result is null, exiting camelCase function 
        ************`)
        return;
      }
      let temp = res.result[0];
      if(temp != null) {
        for(let i = 0; i < Object.keys(res.result).length; ++i) {
          let temp = res.result[i];
          for(let j = 0; j < Object.keys(res.result[i]).length; ++j) {
            let tempString;
            if(Object.keys(res.result[i])[0].substring(0, 2) == 'ID') {
              tempString = Object.keys(res.result[i])[0].substring(0, 2).toLowerCase() + Object.keys(res.result[i])[0].substring(2) 
            }
            else if(Object.keys(res.result[i])[0].substring(0, 3) == 'DOB') {
              tempString = Object.keys(res.result[i])[0].substring(0, 3).toLowerCase();
            }
            else {
              tempString = Object.keys(res.result[i])[0][0].toLowerCase() + Object.keys(res.result[i])[0].substring(1);
            }
          

            let value = res.result[i][Object.keys(res.result[i])[0]];
            delete temp[Object.keys(res.result[i])[0]];
            temp[tempString] = value;
          }
        }
    } else {
      for(let i = 0; i < Object.keys(res.result).length; ++i) {
        let temp = res.result;
        let tempString;
        if(Object.keys(res.result)[0].substring(0, 2) == 'ID') {
          tempString = Object.keys(res.result)[0].substring(0, 2).toLowerCase() + Object.keys(res.result)[0].substring(2);
        }
        else if(Object.keys(res.result)[0].substring(0, 3) == 'DOB') {
          tempString = Object.keys(res.result)[0].substring(0, 3).toLowerCase();
        }
        else {
          tempString = Object.keys(res.result)[0][0].toLowerCase() + Object.keys(res.result)[0].substring(1);
        }

        let value = res.result[Object.keys(res.result)[0]];
        delete temp[Object.keys(res.result)[0]];
        temp[tempString] = value;
      }
    }
    })
  } 

}

